import { render } from "./ViewPlacePage.vue?vue&type=template&id=08649334&ts=true"
import script from "./ViewPlacePage.vue?vue&type=script&lang=ts"
export * from "./ViewPlacePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__